/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */

// Defines the max characters for comparing against the length of a username or text.
export const MAX_CHARACTERS = 15;

/**
 * Provides a utility that formats a username string by limiting its length to a
 * maximum number of characters and appending an ellipsis (...) to indicate that
 * the username has been truncated.
 */
export const formatUsername = (username: string, maxCharacters: number): string => (
  username?.substring(0, maxCharacters).concat('...') || ''
);

/**
 * Provides a utility that determines whether a given charectors exceeds a specified maximum
 * character length, returning either true or false based on this assessment.
 */
export const hasLengthyChars = (chars: string, maxCharacters: number): boolean => (
  !!(chars?.length > maxCharacters)
);
